
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "deleteGeography",
      resolverType: "mutation",
      routePath: "/deleteGeography",
      httpMethod: "POST",
    });
  